export default () => [
  '+ {clickId}',
  '+ {campaignId}',
  '+ {campaignName}',
  '+ {campaignNumber}',
  '+ {cost.USD}',
  '+ {cost.EUR}',
  '+ {cost.CURRENCY}',
  '+ {trafficSourceId}',
  '+ {trafficSourceName}',
  '+ {landingId}',
  '+ {landingName}',
  '+ {landingNumber}',
  '+ {trafficSourceNumber}',
  '+ {affiliateNetworkNumber}',
  '+ {flowNumber}',
  '+ {offerId}',
  '+ {offerName}',
  '+ {offerNumber}',
  '+ {deviceType}',
  '+ {deviceVendor}',
  '+ {deviceModel}',
  '+ {browser}',
  '+ {browserVersion}',
  '+ {os}',
  '+ {osVersion}',
  '+ {country}',
  '+ {countryCode}',
  '+ {city}',
  '+ {region}',
  '+ {isp}',
  '+ {userAgent}',
  '+ {ip}',
  '+ {custom1}',
  '+ {custom2}',
  '+ {customN}',
  '+ {trackingDomain}',
  '+ {referrerDomain}',
  '+ {lang}',
  '+ {connectionType}',
  '+ {mobileCarrier}',
];